export class EntityLock {
public c_lock_id:number | null = null;
public c_staff_id:number | null = null;
public c_lock_month:string | null = null;
public c_lock_reg_user:string | null = null;
public c_lock_reg_at:Date | null = null;
public c_lock_upd_user:string | null = null;
public c_lock_upd_at:Date | null = null;
}